var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSummer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.311 27.223c-8.292 0-15.039 6.757-15.039 15.039 0 8.298 6.747 15.039 15.04 15.039 8.288 0 15.033-6.74 15.033-15.039 0-8.282-6.745-15.039-15.034-15.039zM79.457 39.13h-14.6a3.207 3.207 0 00-3.212 3.214 3.203 3.203 0 003.213 3.198h14.6a3.203 3.203 0 003.21-3.198 3.206 3.206 0 00-3.21-3.214M23.018 42.344a3.204 3.204 0 00-3.21-3.214H5.21A3.205 3.205 0 002 42.344a3.202 3.202 0 003.211 3.198h14.596a3.2 3.2 0 003.211-3.198M42.333 23.025a3.217 3.217 0 003.21-3.215V5.214A3.217 3.217 0 0042.334 2a3.215 3.215 0 00-3.212 3.214V19.81a3.215 3.215 0 003.212 3.215M42.333 61.647a3.215 3.215 0 00-3.212 3.214v14.596a3.215 3.215 0 003.212 3.215 3.217 3.217 0 003.21-3.215V64.861a3.217 3.217 0 00-3.21-3.214M58.736 29.142c.821 0 1.643-.312 2.27-.935l10.322-10.315c1.254-1.263 1.254-3.297 0-4.543a3.195 3.195 0 00-4.541 0L56.464 23.664c-1.254 1.247-1.254 3.28 0 4.543.627.623 1.45.935 2.272.935M23.663 56.464L13.34 66.796a3.192 3.192 0 000 4.527c.626.64 1.448.951 2.27.951.821 0 1.643-.312 2.27-.951l10.323-10.316c1.255-1.246 1.255-3.28 0-4.543a3.225 3.225 0 00-4.541 0M61.006 56.464a3.225 3.225 0 00-4.542 0c-1.254 1.263-1.254 3.297 0 4.543l10.323 10.316c.626.64 1.448.951 2.27.951.821 0 1.643-.312 2.27-.951a3.192 3.192 0 000-4.527L61.007 56.464M23.663 28.207a3.209 3.209 0 002.27.935c.821 0 1.643-.312 2.27-.935 1.256-1.263 1.256-3.296 0-4.543L17.883 13.35a3.195 3.195 0 00-4.541 0c-1.255 1.246-1.255 3.28 0 4.543l10.322 10.315"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummer);
export default __webpack_public_path__ + "static/media/summer.fd7035d6.svg";
export { ForwardRef as ReactComponent };